// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2qe8s","choiceBoxes":"toolbarselects_choiceBoxes__1-yRx","simpleField":"toolbarselects_simpleField__a_t_J"};